const path = require('path')
const fs = require('fs')
const moment = require('moment')

/* gets index.html file and replaces {{ latest_deployment }} with unique string */
function setLastDeploymentString() {
  const deploymentDate = moment().format('YYYY-MM-DD-HH:mm') // unique string by using date
  const indexFilePath = path.resolve(__dirname, '../../public/index.html')
  let indexFile = fs.readFileSync(indexFilePath, 'utf-8')
  indexFile = indexFile.replace('{{ latest_deployment }}', deploymentDate)
  fs.writeFileSync(indexFilePath, indexFile, { encoding: 'utf-8' })
}

/* it fetches the new version of index.html and gets the unique string of body attr "latest-deployment" */
function getLatestDeploymentString() {
  const url = `${window.location.origin}?t=${new Date().getTime()}` // url to invalidate cache (get latest version of index.html)
  return fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      return doc.querySelector('body').getAttribute('latest-deployment')
    })
}

module.exports = { setLastDeploymentString, getLatestDeploymentString }
